import React, { useState, useEffect } from 'react';
import { RotateCcw } from 'lucide-react';

const MemoryMatch = () => {
  const [cards, setCards] = useState([]);
  const [flipped, setFlipped] = useState([]);
  const [matched, setMatched] = useState([]);
  const [moves, setMoves] = useState(0);
  const [isWon, setIsWon] = useState(false);

  useEffect(() => {
    initializeGame();
  }, []);

  const initializeGame = () => {
    const symbols = ['🐶', '🐱', '🐭', '🐹', '🦊', '🐻', '🐼', '🐨'];
    const gameCards = [...symbols, ...symbols].sort(() => Math.random() - 0.5);
    setCards(gameCards.map((symbol, index) => ({ id: index, symbol })));
    setFlipped([]);
    setMatched([]);
    setMoves(0);
    setIsWon(false);
  };

  const handleCardClick = (index) => {
    if (flipped.includes(index) || matched.includes(index) || flipped.length === 2) return;

    const newFlipped = [...flipped, index];
    setFlipped(newFlipped);

    if (newFlipped.length === 2) {
      setMoves(moves + 1);
      if (cards[newFlipped[0]].symbol === cards[newFlipped[1]].symbol) {
        const newMatched = [...matched, ...newFlipped];
        setMatched(newMatched);
        setFlipped([]);

        if (newMatched.length === cards.length) {
          setIsWon(true);
        }
      } else {
        setTimeout(() => setFlipped([]), 600);
      }
    }
  };

  return (
    <div className="container mt-4">
      <div className="row justify-content-center">
        <div className="col-lg-6">
          <div className="card shadow-lg">
            <div className="card-header bg-warning text-dark">
              <h3 className="mb-0">🧠 Memory Match</h3>
            </div>
            <div className="card-body">
              <div className="text-center mb-4">
                <h5 className="text-muted">Mosse: <strong>{moves}</strong></h5>
                <h5 className="text-muted">Coppie trovate: <strong>{matched.length / 2}/{cards.length / 2}</strong></h5>
              </div>

              {isWon && (
                <div className="alert alert-success text-center mb-4">
                  🎉 Hai vinto! Hai impiegato <strong>{moves}</strong> mosse!
                </div>
              )}

              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(4, 1fr)',
                gap: '10px',
                marginBottom: '20px'
              }}>
                {cards.map((card, index) => (
                  <button
                    key={card.id}
                    onClick={() => handleCardClick(index)}
                    className="btn"
                    style={{
                      backgroundColor: flipped.includes(index) || matched.includes(index) ? '#667eea' : '#e0e0e0',
                      color: '#333',
                      fontSize: '2rem',
                      padding: '20px',
                      border: '2px solid #667eea',
                      borderRadius: '8px',
                      cursor: flipped.length === 2 ? 'not-allowed' : 'pointer',
                      height: '80px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      transition: 'all 0.3s ease'
                    }}
                    disabled={flipped.length === 2}
                    aria-label={`Card ${index + 1}`}
                  >
                    {flipped.includes(index) || matched.includes(index) ? card.symbol : '?'}
                  </button>
                ))}
              </div>

              <div className="text-center">
                <button onClick={initializeGame} className="btn btn-primary btn-lg">
                  <RotateCcw size={20} className="me-2" />
                  Nuova Partita
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MemoryMatch;
